'use strict';

var rubiconAccountId = '10698';

module.exports = {
  name: 'Rubicon',

  refresh: function refresh() {
    return null;
  },

  preDfpScript: function preDfpScript() {
    return '<script type=\'text/javascript\' src=\'//ads.rubiconproject.com/header/' + rubiconAccountId + '.js\'></script>';
  }
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL0V4dGVuc2lvbnMvUnViaWNvbkV4dGVuc2lvbi5qcyJdLCJuYW1lcyI6WyJydWJpY29uQWNjb3VudElkIiwibW9kdWxlIiwiZXhwb3J0cyIsIm5hbWUiLCJyZWZyZXNoIiwicHJlRGZwU2NyaXB0Il0sIm1hcHBpbmdzIjoiOztBQUFBLElBQU1BLG1CQUFtQixPQUF6Qjs7QUFFQUMsT0FBT0MsT0FBUCxHQUFpQjtBQUNmQyxRQUFNLFNBRFM7O0FBR2ZDLFdBQVMsbUJBQU07QUFDYixXQUFPLElBQVA7QUFDRCxHQUxjOztBQU9mQyxnQkFBYyx3QkFBTTtBQUNsQix1RkFBOEVMLGdCQUE5RTtBQUNEO0FBVGMsQ0FBakIiLCJmaWxlIjoiUnViaWNvbkV4dGVuc2lvbi5qcyIsInNvdXJjZXNDb250ZW50IjpbImNvbnN0IHJ1Ymljb25BY2NvdW50SWQgPSAnMTA2OTgnO1xuXG5tb2R1bGUuZXhwb3J0cyA9IHtcbiAgbmFtZTogJ1J1Ymljb24nLFxuXG4gIHJlZnJlc2g6ICgpID0+IHtcbiAgICByZXR1cm4gbnVsbDtcbiAgfSxcblxuICBwcmVEZnBTY3JpcHQ6ICgpID0+IHtcbiAgICByZXR1cm4gYDxzY3JpcHQgdHlwZT0ndGV4dC9qYXZhc2NyaXB0JyBzcmM9Jy8vYWRzLnJ1Ymljb25wcm9qZWN0LmNvbS9oZWFkZXIvJHtydWJpY29uQWNjb3VudElkfS5qcyc+PC9zY3JpcHQ+YDtcbiAgfVxufTtcbiJdfQ==


//////////////////
// WEBPACK FOOTER
// ./node_modules/legacy-advertising/dist/Extensions/RubiconExtension.js
// module id = 1515
// module chunks = 0